// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../../utils/BasicAuthAPI";
import { Tabs, Radio, Row, Col } from "antd";
// import LineGraph from "src/components/LineDashboardV/Graph/LineChart";
// import LineGraph from "src/components/ManagerDashboard/Common/Graph/LineGraph";
import GoldenTunnelLineGraph from "./Elements/GoldenTunnelLineGraph";
import GoldenTunnelMeanDeviation from "./Elements/GoldenTunnelMeanDeviation";


// import BasicBarGraph from "./Common/Graph/BasicBarGraph";
import SpcClassIntervalBarGraph from "./Elements/SpcClassIntervalBarGraph";
import SpcCpk from "./Elements/SpcCpk";
// import SpcPerformanceGaugeGraph from  "./Elements/SpcPerformanceGaugeGraph";
// import LineGraphSpc from "src/components/Spc/Elements/LineGraphSpc";

// import ColoredBarGraph from "./Common/Graph/ColoredBarGraph";
// import GaugeGraph from "./Common/Graph/GaugeGraph";
// import "./managerDashboard.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
// E:\GIT\React\_DevOpsReact_01\src\components\LineDashboardV\Graph\PerformanceGaugeGraph.js

const DashboardTabs = {
  1: "ParameterTrend",
  2: "Alerts",
  3: "DataTable",
};
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";
const productionTableStyle = {
  marginTop: "1rem",
  marginBottom: "1rem",
};

class GoldenTunnel extends React.Component {
  state = {
    mainData: null,
    xData: null,
    rData: null,
    linePref: null,
    mtdData: null,
    spcClassIntervalData: null,
    loading: true,
    loginError: false,
    selectedTab: "1",
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value, st);
  };

  componentDidMount() {
    

    this.props.setPageHeader("Golden Parameter Tunnel");
    this._isMounted = true;
    this._isMounted && this.fetchTrendData(this.state.selectedTab);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab) => {
    liracrypt
      // .get("/mdash/trenddata", {
      //   lid: "lid_999",
      //   typ: "MainGraph",
      //   subTyp: DashboardTabs[selectedTab],
      // })

      .get("/textapi", { dn: "GoldenTunnel" })
      .then(({ data }) => {
        

        const newData = { ...data };
        let newDataConfig = {};
        newDataConfig["xData"] = newData["data"]["xData"];
        newDataConfig["rData"] = newData["data"]["rData"];
        newDataConfig["spcClassIntervalData"] =
          newData["data"]["spcClassIntervalData"];
        newDataConfig["spcCpk"] = newData["data"]["spcCpk"];
        

        delete newData["data"]["linePerf"];
        newDataConfig["mainData"] = { ...newData };
        this._isMounted &&
          this.setState({ ...this.state, ...newDataConfig, loading: false });
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div>
            <Radio.Group
              className="managerTabs"
              value={"small"}
              onChange={this.onChange}
            >
              <Radio.Button
                className="ParameterTrend"
                style={{
                  backgroundColor: "#262626",
                  color: "#9c27b0",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="1"
              >
                ParameterTrend
              </Radio.Button>
              <Radio.Button
                className="Alerts"
                style={{
                  backgroundColor: "#262626",
                  color: "#4D83FF",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="2"
              >
                Alerts
              </Radio.Button>
              <Radio.Button
                className="DataTable"
                style={{
                  backgroundColor: "#262626",
                  color: "#7859DF",
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: 600,
                  boxShadow: boxShadow,
                  maxWidth: "200px",
                }}
                value="3"
              >
                Data
              </Radio.Button>
            </Radio.Group>
            {this.state.loading === false ? (
              <div
                style={
                  {
                    // border: "2px solid " + this.state.mainData.data.color,
                    // borderRadius: "10px",
                    // border: "2px solid #3b3b3b",
                    // borderTopColor: this.state.mainData.data.color,
                    // borderTopWidth: "3px",
                  }
                }
              >
                <Row>
                  <Col span={24}>
                    {this.state.xData ? (
                      <GoldenTunnelLineGraph
                        divId={"linegraph01"}
                        title={"Parameter Tunnel - Model EC302 20220313 SH A"}
                        category={"_id"}
                        data={this.state.xData}
                        rotation={270}
                        legendRdg={"Actual Parameter"}
                        colorRdg={"#9b59b6"}
                        valRdg={"rdg"}
                        legendTgt={"Golden Parameter"}
                        valTgt={"tgt"}
                        colorTgt={"#f39c12"}
                        legendLcl={"LCL"}
                        valLcl={"lcl"}
                        colorLcl={"#e74c3c"}
                        legendUcl={"UCL"}
                        valUcl={"ucl"}
                        colorUcl={"#e74c3c"}
                        // legendLsl={"LSL"}
                        // valLsl={"lsl"}
                        // colorLsl={"#2ecc71"}
                        // legendUsl={"USL"}
                        // valUsl={"usl"}
                        // colorUsl={"#2ecc71"}
                      />
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    {this.state.rData ? (
                      <GoldenTunnelMeanDeviation
                        divId={"linegraph02"}
                        title={"Operating Band - Model EC302 20220313 SH A"}
                        category={"_id"}
                        data={this.state.rData}
                        rotation={270}
                        legendRdg={"Drift"}
                        colorRdg={"#9b59b6"}
                        valRdg={"rdg"}
                        legendTgt={"Target"}
                        valTgt={"tgt"}
                        colorTgt={"#e74c3c"}
                        // legendLcl={"LCL"}
                        // valLcl={"lcl"}
                        // colorLcl={"#e74c3c"}
                        // legendUcl={"UCL"}
                        // valUcl={"ucl"}
                        // colorUcl={"#e74c3c"}
                        // legendLsl={"LSL"}
                        // valLsl={"lsl"}
                        // colorLsl={"#2ecc71"}
                        // legendUsl={"USL"}
                        // valUsl={"usl"}
                        // colorUsl={"#2ecc71"}
                      />
                    ) : null}
                  </Col>
                </Row>

                {/* <Row>
                  <Col span={12}>
                    {this.state.spcClassIntervalData ? (
                      <SpcClassIntervalBarGraph
                        divId={"spc01"}
                        title={"Class Interval Distribution"}
                        colVal={"col"}
                        lineVal={"line"}
                        category={"_id"}
                        data={this.state.spcClassIntervalData}
                      />
                    ) : null}
                  </Col>

                  <Col span={12}>
                    {this.state.spcCpk ? (
                      <SpcCpk
                        divId={"spc-02"}
                        title={"CPk Distribution"}
                        colVal={"col"}
                        lineVal={"line"}
                        category={"_id"}
                        data={this.state.spcCpk}
                      />
                    ) : null}
                  </Col>
                </Row> */}

                {/* <Row>
                  <Col span={12}>
                    {FormData ? (
                      <div style={productionTableStyle}>
                        <SummaryGrid
                          url="/textapi"
                          apiName={"SpcSummary"}
                          identity="part"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row> */}

                <Row gutter={24} style={{ marginTop: "10px" }}>
                  <Col span={12}>
                    <div
                      style={{
                        backgroundColor: "#1D1D1D",
                        border: 0,
                        // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                        boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                        borderRadius: "10px",
                        fontWeight: "600",
                      }}
                      className="borderBox"
                    >
                      <div style={{}}>
                        {/* {console.log("m", leftContainer.mainGraph)} */}

                        {/* <SpcPerformanceGaugeGraph
                          height="180px"
                          tsize="20px"
                          graphSetting={
                            this.state.SpcPerformanceGaugeGraph.config
                          }
                          divId={"GuagePerform"}
                          barColor={"#fed330"}
                          labelText={"sdasasas"}
                          labelColor={"#fed330"} */}
                        {/* /> */}
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "5px",
                          marginTop: "5px",
                        }}
                      >
                        {/* <span >
                      {"HELLO"}
                    </span> */}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default GoldenTunnel;
